// /subscriptions/* Wrapper — Credit-Abo-Pläne + aktives Abo + Stripe-Flows.
// Backend: GET /subscriptions/me (Pläne + active), POST /subscriptions/checkout
// (Subscription-Checkout), POST /subscriptions/portal (Stripe Billing-Portal).

import { apiFetch } from './api';

export type BillingCycle = 'monthly' | 'yearly';

export interface SubscriptionPlan {
  id: string;
  name: string;
  credits_per_month: number;
  price_monthly_cents: number;
  price_yearly_cents: number;
}

export interface ActiveSubscription {
  id: string;
  plan_id: string;
  billing_cycle: BillingCycle;
  status: string;
  period_end: string | null;
  monthly_reset_at: string | null;
  cancel_at_period_end: number | boolean | null;
}

export interface SubscriptionMeResponse {
  plans: ReadonlyArray<SubscriptionPlan>;
  active: ActiveSubscription | null;
}

export async function fetchSubscriptionMe(accessToken: string): Promise<SubscriptionMeResponse> {
  return apiFetch<SubscriptionMeResponse>('/subscriptions/me', { accessToken });
}

export async function createSubscriptionCheckout(
  accessToken: string,
  planId: string,
  cycle: BillingCycle,
): Promise<{ url: string }> {
  return apiFetch<{ url: string }>('/subscriptions/checkout', {
    method: 'POST',
    accessToken,
    json: { planId, cycle },
  });
}

export async function openSubscriptionPortal(accessToken: string): Promise<{ url: string }> {
  return apiFetch<{ url: string }>('/subscriptions/portal', {
    method: 'POST',
    accessToken,
  });
}
